<div #isOverflow='textOverflow'
     [class.last]="isLast()"
     [class.mb6]="withBMargin()"
     [matTooltipDisabled]="!isOverflow.value"
     [matTooltip]="tag()?.name"
     [style.max-width.px]="maxWidth"
     class="tag {{finalClassName}}"
     matTooltipPosition="above" textOverflow>
  @if (tag() && tag()?.name) {
    {{ (tag()?.name?.trim() || '') | translate }}
  } @else {
    {{ (title() || '') | translate }}
  }
</div>
